import { ContrarefService } from "../../services/models/interconsult/contraref";
const moduleContraref = {
	namespaced: true,
	state: {
		contrarefs: [],
		loading: false,
	},
	getters: {
		getContrarefs(state) {
			return state.contrarefs;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadContrarefs(state, contrarefs) {
			state.contrarefs = contrarefs;
		},
	},
	actions: {
		async loadContrarefsByIcId({ commit, state }, payload) {
			state.loading = true;
			let contrarefs = await ContrarefService.getByInterconsultId(payload.id);
			commit("loadContrarefs", contrarefs);
			state.loading = false;
		}
	}
}

export default moduleContraref;